export default __webpack_public_path__ + "static/media/qr-template-small-icon-en.0262283c.png";